/*
 * Copyright (c) 2018 Macrofocus GmbH. All Rights Reserved.
 */
package org.mkui.palette

import org.mkui.color.MkColor

/**
 * Palette composed of a defined list of discrete colors.
 */
open class DynamicPalette : AbstractMutablePalette {
    protected var colors: MutableList<MkColor>
    final override var isInverted = false

//    constructor(vararg colors: Int) : this(false, *colors) {
//    }
//
//    constructor(inverted: Boolean, vararg colors: Int) {
//        isInverted = inverted
//        this.colors = ArrayList<CPColor>(colors.size)
//        for (color in colors) {
//            this.colors.add(CPColorFactory.instance.createColor(color))
//        }
//        colorCount = this.colors.size
//    }

    constructor(vararg colors: MkColor) {
        this.colors = colors.toMutableList()
        colorCount = this.colors.size
    }

//    constructor(inverted: Boolean, vararg colors: MkColor) {
//        this.colors = colors.toMutableList()
//        colorCount = this.colors.size
//        isInverted = inverted
//    }

    constructor(colors: List<MkColor>) {
        this.colors = colors.toMutableList()
        colorCount = this.colors.size
    }

    override fun getColor(fraction: Double): MkColor {
        var fraction = fraction
        var inverted = isInverted
        when (cycle) {
            Cycle.REFLECT -> {
                inverted = fraction.toInt() % 2 == 0
                fraction = fraction - fraction.toInt()
            }
            Cycle.REPEAT -> fraction = fraction - fraction.toInt()
            else -> Unit /* no-op */
        }
        return when {
            fraction < lowestFraction -> {
                getColor(lowestFraction)
            }
            fraction > highestFraction -> {
                getColor(highestFraction)
            }
            else -> {
                val index: Int = getEntry(if (!inverted) fraction else 1 - fraction, colorCount, colors.size)
                colors[index]
            }
        }
    }

    protected open val lowestFraction: Double
        protected get() = 0.0
    protected open val highestFraction: Double
        protected get() = 1.0

    override fun getColorAt(fraction: Int): MkColor {
        return if (colorCount == colors.size) {
            when {
                fraction < 0 -> {
                    getColorAt(0)
                }
                fraction > colorCount - 1 -> {
                    getColorAt(colorCount - 1)
                }
                else -> {
                    colors[fraction]
                }
            }
        } else {
            getColor(colorCount / fraction.toDouble())
        }
    }
}